export const DEDUCTIBLE_AMOUNTS = ['0,00', '51,00', '100,00', '102,20', '150,00', '153,30', '175,00', '250,00', '400,00']
